import { useRef } from "react";
import { Button } from "./Button";
import { Dialog } from "./Dialog";

/**
 * Centered modal that nudges the user to upgrade — the single shared surface for
 * the global `402 quota_exceeded` handler and any plan-gated CTA. Presentational
 * and i18n-free: the caller passes already-translated copy and wires the
 * actions. Self-contained (portal + backdrop + Escape + focus), monochrome.
 */
export interface UpgradeModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  /** Primary CTA label (e.g. "See plans"). */
  primaryLabel: string;
  onPrimary: () => void;
  /** Dismiss label (e.g. "Not now"). */
  secondaryLabel: string;
  /** Accessible label for the backdrop dismiss button. */
  closeLabel: string;
}

export function UpgradeModal({
  open,
  onClose,
  title,
  description,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  closeLabel,
}: UpgradeModalProps) {
  const primaryRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      closeLabel={closeLabel}
      initialFocusRef={primaryRef}
      className="max-w-[420px]"
      footer={
        <>
          <Button variant="subtle" size="md" onClick={onClose}>
            {secondaryLabel}
          </Button>
          <Button ref={primaryRef} variant="ink" size="md" onClick={onPrimary}>
            {primaryLabel}
          </Button>
        </>
      }
    />
  );
}
